import styled from '@emotion/styled';
import { FC } from 'react';
import { H2 } from '../../../components/styles';
import { VoteResult } from '../../../config/variables';
import { colors } from '../../../styles/variables/colors';
import { Party } from '../Detail';
import {
  StyledDetailResultVote,
  StyledDetailResultVoteParty,
  StyledVotes,
} from '../Detail.style';

interface VisualizationProps {
  title: string;
  option: VoteResult;
  elements: Array<any>;
  votes: Array<any>;
  getPartyColor: (party: Party) => string;
}

const StyledContainer = styled.div`
  background-color: ${colors.lightGrey};
  padding: 30px;
`;

const Visualization: FC<VisualizationProps> = (props) => {
  const { title, option, elements, votes, getPartyColor } = props;

  return (
    <StyledContainer>
      <H2 style={{ fontSize: 24, marginBottom: 16 }}>{title}</H2>
      <div style={{ minHeight: 104 }}>
        {elements.length > 0 && (
          <StyledVotes count={elements.length}>{elements}</StyledVotes>
        )}
        {elements.length === 0 && (
          <>
            {option === VoteResult.Accepted ? 'Pro návrh' : 'Proti návrhu'}{' '}
            nikdo nehlasoval.
          </>
        )}
      </div>
      {votes.length > 0 && (
        <>
          <H2 style={{ fontSize: 20, marginTop: 32, marginBottom: 20 }}>
            Seznam hlasujících
          </H2>
          {votes.map((vote: any) => (
            <StyledDetailResultVote key={vote.id}>
              <StyledDetailResultVoteParty
                color={getPartyColor(vote.representativeLink.party)}
              ></StyledDetailResultVoteParty>
              <span>
                <strong>{correctName(vote.representativeLink.name)} </strong> (
                {vote.representativeLink.party})
              </span>
            </StyledDetailResultVote>
          ))}
        </>
      )}
    </StyledContainer>
  );
};

export default Visualization;

/**
 * Funkce na korekci jmen zastupitelu, kteri behem mandatu zmenili jmeno
 *
 * @param name jmeno zastupitele
 * @returns opravene jmeno zastupitele
 */
export const correctName = (name: string): string => {
  if (['Kristýna Černá', 'Kristýna Švarcová'].includes(name.trim())) {
    return 'Kristýna Černá (roz. Švarcová)';
  }

  return name;
};
